import React from 'react'
import filesize from 'filesize'
import {
  ProgressBar,
  progressBarStateEnum,
} from '@components/common/ProgressBar'

import { HiDocument } from 'react-icons/hi'

export const FileIcon = ({
  fileExtension,
  iconClassName,
  labelClassName,
}: {
  fileExtension: string
  iconClassName?: string
  labelClassName?: string
}) => (
  <div className="relative flex">
    <div className="flex-shrink-0">
      <HiDocument className={`w-20 h-[44px] ${iconClassName}`} />
    </div>

    <span
      className={`absolute w-20 text-center -translate-y-1/2 text-core-white top-1/2 ${labelClassName}`}
    >
      {fileExtension}
    </span>
  </div>
)

export const allowedExtensions = [
  'JPG',
  'JPEG',
  'PNG',
  'PDF',
  'SVG',
  'EPS',
  'AI',
  'PSD',
  'OTF',
  'TTF',
]

export const mapExtensionToColor = {
  JPG: 'text-creative-purple',
  JPEG: 'text-creative-purple',
  PNG: 'text-eco-dark-green',
  PDF: 'text-core-rose',
  SVG: 'text-creative-teal',
  EPS: 'text-creative-yellow',
  AI: 'text-creative-yellow',
  PSD: 'text-industry-blue',
  OTF: 'text-core-grey-70',
  TTF: 'text-core-grey-70',
  '?': 'text-core-rose',
}

export function FileUploadProgressBar({
  uploadPercentage,
  file,
  title,
  state = progressBarStateEnum.IDLE,
  handleRemoveButtonClick,
  selected,
  onSelect,
  disabled,
}: {
  file: File
  title: string
  uploadPercentage: number
  className?: string
  state: progressBarStateEnum
  handleRemoveButtonClick?: () => void
  selected: boolean
  onSelect: (file: File) => void
  disabled: boolean
}) {
  const fileName = file?.name || ''
  const fileExtension = file?.name?.split('.')?.pop()?.toUpperCase() || ''
  const fileSize = file?.size ? filesize(file?.size) : ''

  const isAllowedExtension =
    allowedExtensions.indexOf(fileExtension.toUpperCase()) !== -1

  return (
    <ProgressBar
      title={title ?? fileName}
      subtitle={fileSize}
      icon={
        <FileIcon
          fileExtension={isAllowedExtension ? fileExtension : '?'}
          iconClassName={
            mapExtensionToColor[isAllowedExtension ? fileExtension : '?']
          }
        />
      }
      uploadPercentage={uploadPercentage}
      state={state}
      handleRemoveButtonClick={handleRemoveButtonClick}
      className={`mb-4`}
      selected={selected}
      disabled={disabled}
      onClick={
        onSelect
          ? () => {
              onSelect(file)
            }
          : undefined
      }
    />
  )
}
